import { type FC, useContext } from "react";
import { useDrag } from "react-dnd";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import { DragDropEditorContext, type DragDropNewItem } from "./DragDropTypes";

interface Props {
    type: string;
    onHighlight: (type: string | null) => void;
}

export const DragDropNewComponent: FC<Props> = ({ type, onHighlight }) => {
    const { items } = useContext(DragDropEditorContext);

    const [ , drag ] = useDrag(() => ({
        type,
        item: {
            new: true,
            type,
        } as DragDropNewItem,
    }), []);

    const definition = items[type];

    if(!definition) {
        return null;
    }

    return (
        <div
            ref={el => {
                drag(el);
            }}
            className={
                "flex items-center justify-center flex-col w-24 h-24 p-1 rounded shadow cursor-pointer " +
                "text-center border border-neutral-300 hover:bg-neutral-200 dark:border-0 dark:bg-dark-900 " +
                "dark:hover:bg-dark-700"
            }
            onMouseOver={() => {
                onHighlight(type);
            }}
            onMouseOut={() => {
                onHighlight(null);
            }}
        >
            <div className="text-3xl mb-1">
                <FontAwesomeLight icon={definition.icon} />
            </div>
            {definition.name}
        </div>
    );
};
